import { useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { CreateUnifiedOrderDialog } from "./unified/create-unified-order-dialog";
import { Plus, ChevronDown, Package, Layers } from "lucide-react";
import { toast } from "sonner";

export function CreateOrderDropdown() {
  const navigate = useNavigate();
  const [unifiedDialogOpen, setUnifiedDialogOpen] = useState(false);

  const handleUnifiedOrderSuccess = (orderId: string) => {
    toast.success("Order Created", {
      description: `Order ${orderId} created.`,
    });
    setUnifiedDialogOpen(false);
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button>
            <Plus className="h-4 w-4 mr-2" />
            Create Order
            <ChevronDown className="h-4 w-4 ml-2" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => setUnifiedDialogOpen(true)}>
            <Package className="h-4 w-4 mr-2" />
            Single Order
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => navigate("/fulfillment/orders/bulk-create")}
          >
            <Layers className="h-4 w-4 mr-2" />
            Bulk Create
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <CreateUnifiedOrderDialog
        open={unifiedDialogOpen}
        onOpenChange={setUnifiedDialogOpen}
        onSuccess={handleUnifiedOrderSuccess}
      />
    </>
  );
}
